import { useEffect } from 'react';
import { Mail, MessageCircle, Home, Package, Grid, Heart, Search, Sparkles } from 'lucide-react';
const Footer = () => {
  const companyLinks = [{
    label: 'בית',
    href: '/',
    icon: Home
  }, {
    label: 'קטגוריות',
    href: '/products',
    icon: Package
  }, {
    label: 'סוכן חכם',
    href: '/smart-agent',
    icon: Sparkles
  }, {
    label: 'אודות',
    href: '/about',
    icon: Heart
  }];

  useEffect(() => {
    // Inject Google Merchant Widget script
    const script = document.createElement('script');
    script.id = 'merchantWidgetScript';
    script.src = "https://www.gstatic.com/shopping/merchant/merchantwidget.js";
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);

    const handleLoad = () => {
      if ((window as any).merchantwidget) {
        (window as any).merchantwidget.start({
          merchant_id: 5721242591,
          position: 'BOTTOM_RIGHT' // Or 'BOTTOM_LEFT' based on your preference
        });
      }
    };

    script.addEventListener('load', handleLoad);

    return () => {
      document.body.removeChild(script);
      script.removeEventListener('load', handleLoad);
    };
  }, []);

  return <footer className="bg-primary text-primary-foreground relative z-10 overflow-hidden border-t-0 before:hidden after:hidden [&_*]:border-none" style={{ backgroundImage: 'none', backgroundColor: 'hsl(210 11% 15%)', isolation: 'isolate' }}>
    <div className="container mx-auto px-4 pt-16 pb-24 lg:pb-16">
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
        {/* Company Info */}
        <div className="space-y-6">
          <div className="flex justify-center md:justify-start">
            <img src="/uploads/126607ab-a19b-43b5-a9b4-11c3949c1325.png" alt="Excess Market" className="h-12 w-auto" loading="lazy" sizes="48px" srcSet="/uploads/126607ab-a19b-43b5-a9b4-11c3949c1325.png 1008w" />
          </div>
          <p className="text-primary-foreground/80 hebrew-body">
            הפלטפורמה המובילה בישראל לחומרי בנייה במחירים מעולים. מחברים בין ספקים וקונים בצורה יעילה ומהימנה.
          </p>
        </div>

        {/* Company Links */}
        <div className="space-y-6">
          <h3 className="text-xl font-semibold hebrew-heading">החברה</h3>
          <ul className="space-y-3">
            {companyLinks.map(link => (
              <li key={link.label}>
                {link.label === 'סוכן חכם' ? (
                  <div className="text-primary-foreground/50 flex items-center gap-3 cursor-not-allowed">
                    <link.icon className="h-5 w-5" />
                    {link.label}
                    <span className="bg-muted text-muted-foreground text-[10px] px-1.5 py-0.5 rounded-full whitespace-nowrap">
                      בקרוב
                    </span>
                  </div>
                ) : (
                  <a href={link.href} className="text-primary-foreground/80 hover:text-lime transition-smooth hebrew-body flex items-center gap-3">
                    <link.icon className="h-5 w-5 text-lime" />
                    {link.label}
                  </a>
                )}
              </li>
            ))}
          </ul>
        </div>

        {/* Contact Info */}
        <div className="space-y-6">
          <h3 className="text-xl font-semibold hebrew-heading">יצירת קשר</h3>
          <div className="space-y-4">
            <div className="flex items-center gap-3">
              <MessageCircle className="h-5 w-5 text-lime" />
              <a href="/contact" className="text-primary-foreground/80 hover:text-lime transition-smooth hebrew-body">
                צור קשר
              </a>
            </div>
            <div className="flex items-center gap-3">
              <Search className="h-5 w-5 text-lime" />
              <a href="/contact?tab=special-search" className="text-primary-foreground/80 hover:text-lime transition-smooth hebrew-body">
                מצא לי מוצר
              </a>
            </div>
            <div className="flex items-center gap-3">
              <Mail className="h-5 w-5 text-lime" />
              <span className="text-primary-foreground/80">info@excess-market.co.il</span>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
        <p className="text-primary-foreground/60 text-sm hebrew-body">
          © 2026 Excess Market. כל הזכויות שמורות.
        </p>
        <div className="flex gap-8 text-sm">
          <a href="/terms" className="text-primary-foreground/60 hover:text-lime transition-smooth">
            תנאי שימוש
          </a>
          <a href="/privacy" className="text-primary-foreground/60 hover:text-lime transition-smooth">
            פרטיות
          </a>
          <a href="/accessibility" className="text-primary-foreground/60 hover:text-lime transition-smooth">
            נגישות
          </a>
        </div>
      </div>
    </div>
  </footer>;
};
export default Footer;